import { useQuery, UseQueryOptions } from "react-query";
import { IInteractionMessage, IInteractionMessagesGetQueryParameters, Route } from "@edgetier/watchtower-types";
import { AxiosError } from "axios";
import { getAllPaginatedItems } from "utilities/get-all-paginated-items";

/**
 * Request interactions messages from the backend.
 * @param url             The URL of the request.
 * @param queryParameters Any query parameters to be sent with the request.
 * @returns An array of interactions messages.
 */
const requestAllInteractionsMessages = async (url: string, queryParameters: {}) => {
    const data = await getAllPaginatedItems<IInteractionMessage>(url, { params: queryParameters });
    return data;
};

/**
 * A query to get interactions messages from the backend.
 * @param queryParameters Optional query parameters to send with the request.
 * @param options         Query options.
 * @returns
 */
export const useAllInteractionsMessages = <T = IInteractionMessage[]>(
    queryParameters: IInteractionMessagesGetQueryParameters = {},
    options: Omit<UseQueryOptions<IInteractionMessage[], AxiosError, T>, "queryKey" | "queryFn"> = {}
) => {
    const url = Route.InteractionsMessages;
    return useQuery<IInteractionMessage[], AxiosError, T>(
        [url, queryParameters, "all"],
        () => requestAllInteractionsMessages(url, queryParameters),
        options
    );
};
